import { encode as base64_encode } from "base-64";
import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class KeyNotTaggedReportStore {
  keyNotTagged = [];

  total = 0;
  loading = false;
  rootStore;
  loadingData = false;
  pageSize = 0;

  constructor(rootStore) {
    makeObservable(this, {
      keyNotTagged: observable,
      pageSize: observable,
      total: observable,
      loading: observable,
      loadingData: observable,

      loadData: action,
      exportExcel: action,
      exportpdf: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    offset,
    limit,
    vehicleId,
    driverId,
    fromDate,
    toDate,
    interval,
    pageNo,
    filterBy,
  }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      driverId: driverId,
      fromDate: fromDate,
      toDate: toDate,
      interval: interval,
      offset: offset,
      limit: limit,
      page: pageNo,
      filterBy: filterBy,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=keyNotTagged", "postData=" + base64Input);
    this.total = parseInt(response?.data?.data?.TotalCount);

    this.keyNotTagged = response?.data?.data?.startStopData;
    this.pageSize = this.travelReport?.length;
    this.loading = false;
  }

  async exportExcel(getData) {
    let lang = "english";

    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportKeyNotTaggedexcel&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      "&userId=" +
      getData.userId +
      "&filterby=" +
      getData.filterby +
      "&driverId=" +
      getData.driverId +
      "&int=" +
      getData.interval +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }

  async exportpdf(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportKeyNotTaggedpdf&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      "&int=" +
      getData.interval +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }
}
export default KeyNotTaggedReportStore;
